module.exports = __webpack_public_path__ + "img/career-3-our-culture.51e997bb.jpg";